import { ImageProps } from 'next/image'
import { FastlyImage } from '@components/common/image'
type TestimonialCardSimpleProps = {
  /**
   * Avatar image of the person giving the testimonial
   */
  image: ImageProps
  /**
   * Name of the person giving the testimonial
   */
  title: string
  /**
   * Description of the person giving the testimonial
   */
  subtitle: string
  /**
   * The actual testimonial
   */
  message: string
}
const TestimonialCardSimple = ({
  image,
  title,
  subtitle,
  message,
}: TestimonialCardSimpleProps) => {
  return (
    <div className="bg-orange-100 rounded-xl py-5 px-8 flex flex-col lg:flex-row">
      <div className="mb-3 lg:mb-0 lg:mr-6 flex justify-center">
        <FastlyImage {...image} />
      </div>
      <div className="flex flex-col justify-between lg:w-2/3">
        <p>{message}</p>
        <div>
          <h5 className="font-600">{title}</h5>
          <h6>{subtitle}</h6>
        </div>
      </div>
    </div>
  )
}

export default TestimonialCardSimple
